import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d2d84e1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "form"
};
const _hoisted_4 = {
  class: "file",
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_5 = {
  class: "file-icon"
};
const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Загрузить обложку", -1));

const _hoisted_8 = {
  class: "form-row"
};
const _hoisted_9 = {
  class: "form-radio"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "radio1"
}, [/*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createTextVNode("Публичная подборка")], -1));

const _hoisted_11 = {
  class: "form-radio"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "radio2"
}, [/*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createTextVNode("Приватная подборка")], -1));

const _hoisted_13 = {
  key: 0,
  style: {
    "padding": "5px",
    "background-color": "#eee",
    "margin-top": "10px"
  }
};
const _hoisted_14 = {
  class: "form-group",
  style: {
    "margin-top": "60px"
  }
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label"
}, "Название подборки", -1));

const _hoisted_16 = {
  class: "form-group"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label"
}, "Описание подборки", -1));

const _hoisted_18 = {
  class: "add-form"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "block-title"
}, " добавить работу в подборку ", -1));

const _hoisted_20 = {
  class: "form-tabs"
};
const _hoisted_21 = {
  class: "work-search"
};
const _hoisted_22 = {
  class: "works-wrap"
};
const _hoisted_23 = {
  class: "greed"
};
const _hoisted_24 = {
  class: "flex-row"
};
const _hoisted_25 = {
  class: "item"
};
const _hoisted_26 = {
  class: "checkbox"
};
const _hoisted_27 = ["value", "id"];
const _hoisted_28 = ["for"];
const _hoisted_29 = {
  class: "item-img"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "item-title"
};
const _hoisted_32 = {
  class: "item-text"
};
const _hoisted_33 = {
  class: "form-more"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "file",
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_36 = {
  class: "file-icon"
};
const _hoisted_37 = ["src"];

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Загрузить работу", -1));

const _hoisted_39 = {
  class: "form-group"
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "Название Работы", -1));

const _hoisted_41 = ["onUpdate:modelValue"];
const _hoisted_42 = {
  class: "form-group"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "ФИО автора", -1));

const _hoisted_44 = ["onUpdate:modelValue"];
const _hoisted_45 = {
  class: "form-group"
};

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "Краткое описание", -1));

const _hoisted_47 = ["onUpdate:modelValue"];
const _hoisted_48 = {
  class: "form-group"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "Цена", -1));

const _hoisted_50 = ["onUpdate:modelValue"];
const _hoisted_51 = {
  class: "form-group"
};

const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "Материал", -1));

const _hoisted_53 = ["onUpdate:modelValue"];
const _hoisted_54 = {
  class: "form-group"
};

const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label2"
}, "Размер", -1));

const _hoisted_56 = ["onUpdate:modelValue"];
const _hoisted_57 = {
  class: "form-more"
};
const _hoisted_58 = {
  class: "form-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_upload = _resolveComponent("el-upload");

  const _component_Check = _resolveComponent("Check");

  const _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.title), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_upload, {
    class: "avatar-uploader",
    "show-file-list": false,
    "on-change": $options.handlerSelectPhoto,
    "auto-upload": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.form && $data.form.imageWithPath ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $data.form.imageWithPath,
      class: "image",
      alt: ""
    }, null, 8, _hoisted_6)) : (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      class: "avatar-uploader-icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    }))]), _hoisted_7])]),
    _: 1
  }, 8, ["on-change"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    value: "4",
    id: "radio1",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.status_id = $event)
  }, null, 512), [[_vModelRadio, $data.form.status_id]]), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    value: "3",
    id: "radio2",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.status_id = $event)
  }, null, 512), [[_vModelRadio, $data.form.status_id]]), _hoisted_12])]), $data.form.status_id === '4' ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Подборка станет публичной после успешной модерации ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_hoisted_15, _withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.name = $event),
    class: "form-input",
    placeholder: "Введите название подборки"
  }, null, 512), [[_vModelText, $data.form.name]])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _withDirectives(_createElementVNode("textarea", {
    type: "text",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.description = $event),
    class: "form-textarea",
    placeholder: "Введите описание"
  }, null, 512), [[_vModelText, $data.form.description]])])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: _normalizeClass({
      'active': $data.worksTab === 'attach'
    }),
    onClick: _cache[4] || (_cache[4] = $event => $data.worksTab = 'attach')
  }, "Добавить работу из коллекции сайта", 2), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: _normalizeClass({
      'active': $data.worksTab === 'create'
    }),
    onClick: _cache[5] || (_cache[5] = $event => $data.worksTab = 'create')
  }, "Добавить работу из своей коллекции", 2)]), $data.worksTab === 'attach' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("input", {
    type: "text",
    onInput: _cache[6] || (_cache[6] = (...args) => $options.searchWorks && $options.searchWorks(...args)),
    placeholder: "Начните вводить название"
  }, null, 32)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.works, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "col-3",
      key: item.id
    }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("input", {
      type: "checkbox",
      value: item.id,
      id: 'check' + index,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.workIds = $event)
    }, null, 8, _hoisted_27), [[_vModelCheckbox, $data.form.workIds]]), _createElementVNode("label", {
      for: 'check' + index
    }, [_createElementVNode("span", null, [$data.form.workIds.indexOf(item.id) !== -1 ? (_openBlock(), _createBlock(_component_Check, {
      key: 0
    })) : _createCommentVNode("", true)])], 8, _hoisted_28)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
      src: item.thumbWithPath,
      alt: ""
    }, null, 8, _hoisted_30)]), _createElementVNode("div", _hoisted_31, _toDisplayString(item.author.name), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(item.name), 1)])]);
  }), 128))])]), _createElementVNode("div", _hoisted_33, [$data.shownNextButton ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[8] || (_cache[8] = (...args) => $options.showNext && $options.showNext(...args))
  }, "Показать еще... ")) : _createCommentVNode("", true)])])), [[_directive_loading, $data.worksLoading]])], 64)) : _createCommentVNode("", true), $data.worksTab === 'create' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.userWorks, (itemForm, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["customer-work", {
        'first-item': !index
      }])
    }, [$data.form.userWorks.length > 1 ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "remove-button",
      onClick: $event => $options.removeCustomWork(index)
    }, "Удалить", 8, _hoisted_34)) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
      class: "avatar-uploader",
      "show-file-list": false,
      "on-change": upload => $options.handlerSelectWorkPhoto(index, upload),
      "auto-upload": false
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [itemForm.thumbWithPath ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: itemForm.thumbWithPath,
        class: "image",
        alt: ""
      }, null, 8, _hoisted_37)) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        class: "avatar-uploader-icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      }))]), _hoisted_38])]),
      _: 2
    }, 1032, ["on-change"]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => itemForm.name = $event,
      type: "text",
      class: "form-input",
      placeholder: "Начните вводить название"
    }, null, 8, _hoisted_41), [[_vModelText, itemForm.name]])]), _createElementVNode("div", _hoisted_42, [_hoisted_43, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => itemForm.author = $event,
      type: "text",
      class: "form-input",
      placeholder: "Bведите ФИО"
    }, null, 8, _hoisted_44), [[_vModelText, itemForm.author]])]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": $event => itemForm.description = $event,
      type: "text",
      class: "form-textarea",
      placeholder: "Начните вводить описание"
    }, null, 8, _hoisted_47), [[_vModelText, itemForm.description]])]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => itemForm.price = $event,
      type: "text",
      class: "form-input",
      placeholder: "Укажите цену"
    }, null, 8, _hoisted_50), [[_vModelText, itemForm.price]])]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => itemForm.material = $event,
      type: "text",
      class: "form-input",
      placeholder: "Укажите материалы"
    }, null, 8, _hoisted_53), [[_vModelText, itemForm.material]])]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => itemForm.size = $event,
      type: "text",
      class: "form-input",
      placeholder: "Укажите размер"
    }, null, 8, _hoisted_56), [[_vModelText, itemForm.size]])])], 2);
  }), 128)), _createElementVNode("div", _hoisted_57, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[9] || (_cache[9] = $event => $data.form.userWorks.push({}))
  }, "Добавить еще работу + ")])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_58, [_createElementVNode("button", {
    class: "button",
    onClick: _cache[10] || (_cache[10] = (...args) => $options.handlerSubmit && $options.handlerSubmit(...args))
  }, "Опубликовать")])])]);
}